module.exports = __webpack_public_path__ + "static/media/szigeny.d46ca541.png";